module.exports = __webpack_public_path__ + "assets/img/email-new.7156608d.svg";